/* assets/frenly-collections.js (v2.66 collections, 18 Oct 2026)
   Behaviour for snippets/frenly-collection-bar.liquid and the Show more button in
   sections/main-collection-product-grid.liquid. Delegated listeners, so it keeps working after
   facets.js re-renders the grid. Every control is a real link or select, so it all works without JS. */
(function () {
  if (window.__fbCollections) return;
  window.__fbCollections = true;

  var go = function (mutate) {
    var u = new URL(location.href);
    mutate(u.searchParams);
    u.searchParams.delete('page');
    location.href = u.toString();
  };

  /* Sort */
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-fcb-sort]');
    if (!s) return;
    go(function (q) { q.set('sort_by', s.value); });
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t) return;

    /* Filter: opens the theme's own filter drawer */
    var f = t.closest('[data-fcb-filter]');
    if (f) {
      var s = document.querySelector('#main-collection-filters menu-drawer summary') || document.querySelector('menu-drawer.mobile-facets__wrapper summary') || document.querySelector('summary.mobile-facets__open-wrapper');
      if (s) { e.preventDefault(); s.click(); }
      else { var side = document.getElementById('main-collection-filters'); if (side) side.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }

    /* In stock switch: remembered for this visit, so the collection defaults leave it alone */
    var st = t.closest('[data-fcb-stock]');
    if (st) {
      e.preventDefault();
      var on = st.classList.contains('is-on');
      try { if (on) sessionStorage.setItem('fbStockAll', '1'); else sessionStorage.removeItem('fbStockAll'); } catch (err) {}
      st.classList.toggle('is-on', !on);
      st.setAttribute('aria-checked', String(!on));
      go(function (q) { if (on) q.delete('filter.v.availability'); else q.set('filter.v.availability', '1'); });
      return;
    }

    /* Price chips keep every other filter and the sort */
    var pc = t.closest('[data-fcb-price]');
    if (pc) {
      e.preventDefault();
      var parts = pc.getAttribute('data-fcb-price').split('&');
      go(function (q) {
        q.delete('filter.v.price.gte'); q.delete('filter.v.price.lte');
        parts.forEach(function (p) { var kv = p.split('='); q.set('filter.v.price.' + kv[0], kv[1]); });
      });
      return;
    }

    /* Show more: adds the next page under the grid, falls back to the link */
    var more = t.closest('[data-fcb-more-btn]');
    if (more && window.fetch && window.DOMParser) {
      var grid = document.getElementById('product-grid');
      var sid = grid && grid.getAttribute('data-id');
      if (!grid || !sid) return;
      e.preventDefault();
      if (more.getAttribute('aria-busy') === 'true') return;
      more.setAttribute('aria-busy', 'true');
      more.textContent = 'Loading';
      var url = new URL(more.href, location.href);
      url.searchParams.set('section_id', sid);
      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('#product-grid > li.grid__item:not(.fbfl-trust)');
          if (!items.length) throw new Error('empty');
          var seen = {};
          grid.querySelectorAll('a[href*="/products/"]').forEach(function (a) { seen[a.getAttribute('href').split('?')[0]] = 1; });
          var added = 0;
          items.forEach(function (li) {
            var a = li.querySelector('a[href*="/products/"]');
            var k = a && a.getAttribute('href').split('?')[0];
            if (k && seen[k]) return;
            if (k) seen[k] = 1;
            grid.appendChild(document.importNode(li, true));
            added++;
          });
          var next = doc.querySelector('[data-fcb-more-btn]');
          var shown = (parseInt(more.getAttribute('data-shown'), 10) || 0) + items.length;
          var total = parseInt(more.getAttribute('data-total'), 10) || shown;
          var n = document.querySelector('[data-fcb-more-n]');
          if (n) n.textContent = 'Showing ' + Math.min(shown, total) + ' of ' + total;
          if (next) {
            more.href = next.getAttribute('href');
            more.setAttribute('data-shown', String(shown));
            more.textContent = 'Show more';
            more.removeAttribute('aria-busy');
          } else {
            var box = more.closest('[data-fcb-more]');
            more.remove();
            if (box && n) n.textContent = 'Showing all ' + total;
          }
          var pages = document.querySelector('.fcb-pages');
          if (pages) pages.remove();
          document.dispatchEvent(new CustomEvent('fb:collection:more', { detail: { added: added } }));
        })
        .catch(function () { location.href = more.href; });
    }
  });

  /* Keep the bar under the sticky site header */
  var bar, header, ticking = false;
  var place = function () {
    ticking = false;
    bar = document.querySelector('[data-fcb]');
    if (!bar) return;
    header = header || document.querySelector('.section-header');
    var top = 0;
    if (header) {
      var cs = getComputedStyle(header);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var r = header.getBoundingClientRect();
        top = Math.max(0, Math.round(r.bottom));
      }
    }
    bar.style.setProperty('--fcb-top', top + 'px');
    var br = bar.getBoundingClientRect();
    bar.classList.toggle('is-stuck', br.top <= top + 1 && window.scrollY > 0);
    /* v2.75 (25 Oct 2026, Marshall: the bar floated over an empty shadowed gap with no products under it).
       Once the last row of Pops has scrolled up under the bar, the bar steps away until the grid is back. */
    var grid = document.getElementById('product-grid') || document.querySelector('.product-grid-container');
    var past = false;
    if (grid && bar.classList.contains('is-stuck')) {
      var gr = grid.getBoundingClientRect();
      past = gr.bottom < br.bottom + 200;
    }
    bar.classList.toggle('is-past', past);
  };
  /* v2.75 (25 Oct 2026, Marshall: the bar slid over the header): the site header slides in and out after the scroll
     stops, so keep following it for a few frames instead of only on scroll events. */
  var follow = 0;
  var chase = function () { place(); if (follow-- > 0) requestAnimationFrame(chase); };
  var onScroll = function () { var idle = follow <= 0; follow = 24; if (idle) requestAnimationFrame(chase); };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
})();

/* v2.75 (25 Oct 2026, visual audit G7, Collection repair report /mnt/project-files/collections/2026-10-25-twin-listings.md):
   two real boxes of the same Pop are separate listings with the same title and price, so the grid showed twins side by
   side. Show the first card only and add "2 boxes in stock, compare" under its name, linking to a search for that title.
   Listings are never changed; this only hides the repeat card on this page. */
(function () {
  var run = function () {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var first = {};
    Array.prototype.forEach.call(grid.querySelectorAll(':scope > li.grid__item'), function (li) {
      if (li.dataset.fbTwin === 'hide') return;
      var h = li.querySelector('.card__heading');
      if (!h) return;
      var title = h.textContent.replace(/\s+/g, ' ').trim();
      /* 25 Oct (checker TWIN): the same Pop can carry " (1)", a different case, an accent or a different price
         (two boxes, one dearer). The buyer still sees the same Pop twice, so match on the cleaned name only. */
      var key = title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s*\(\d+\)\s*$/, '').replace(/\s+/g, ' ').trim();
      var f = first[key];
      if (!f) { first[key] = { li: li, n: 1, title: title }; return; }
      f.n += 1;
      li.dataset.fbTwin = 'hide';
      li.hidden = true;
      var note = f.li.querySelector('.fb-twin-note');
      if (!note) {
        note = document.createElement('a');
        note.className = 'fb-twin-note';
        note.href = '/search?type=product&q=' + encodeURIComponent(f.title);
        (f.li.querySelector('.card__information') || f.li).appendChild(note);
      }
      note.textContent = f.n + ' boxes in stock, compare';
    });
  };
  var start = function () {
    run();
    var grid = document.getElementById('product-grid');
    var wrap = grid && grid.parentElement;
    if (wrap) new MutationObserver(function () { run(); }).observe(wrap, { childList: true, subtree: false });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
